









import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class Paragraph extends Vue {
  @Prop(String) private title: string;

  constructor() {
    super();
  }
}
